new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        buyButtonWasVisible: false,
        lastScrollY: 0,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea && (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right'))) {
                const productPhoto = document.getElementById('product-photo');
                const photoListItems = photoThumbs.querySelectorAll('#photo-list li');
                const galleryItems = productPhoto ? productPhoto.querySelectorAll(':scope > .product-detail__gallery-item') : [];

                if (productPhoto && photoListItems.length && galleryItems.length) {
                    const setActivePhoto = (index) => {
                        photoListItems.forEach(item => item.classList.remove('active'));
                        galleryItems.forEach(item => item.classList.remove('active'));

                        if (photoListItems[index] && galleryItems[index]) {
                            photoListItems[index].classList.add('active');
                            galleryItems[index].classList.add('active');
                        }
                    };

                    const scrollToPhoto = (index) => {
                        const targetPhoto = galleryItems[index];
                        if (!targetPhoto) return;

                        setActivePhoto(index);
                        productPhoto.scrollTo({
                            top: targetPhoto.offsetTop - galleryItems[0].offsetTop,
                            behavior: 'smooth'
                        });
                    };

                    setActivePhoto(0);

                    photoListItems.forEach((item, index) => {
                        item.addEventListener('click', () => scrollToPhoto(index));
                    });

                    let galleryScrollTicking = false;
                    productPhoto.addEventListener('scroll', () => {
                        if (galleryScrollTicking) return;

                        galleryScrollTicking = true;
                        requestAnimationFrame(() => {
                            const firstPhotoTop = galleryItems[0].offsetTop;
                            let activeIndex = 0;
                            let shortestDistance = Infinity;

                            galleryItems.forEach((item, index) => {
                                const itemTop = item.offsetTop - firstPhotoTop;
                                const distance = Math.abs(productPhoto.scrollTop - itemTop);

                                if (distance < shortestDistance) {
                                    shortestDistance = distance;
                                    activeIndex = index;
                                }
                            });

                            setActivePhoto(activeIndex);
                            galleryScrollTicking = false;
                        });
                    }, { passive: true });
                }
            }

            // if(photoArea.classList.contains('default')) {
            //     if (window.matchMedia("(min-width: 992px)").matches) {
            //         let lastScrollTop = 0;

            //         function animeScroll() {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             const banner = document.querySelector('.product-detail__banner');
            //             const appHeader = document.getElementById('app_header');

            //             if (photoScroll) {
            //                 const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                 const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                 const containerHeight = $container.outerHeight();
            //                 const containerTop = $container.offset() ? $container.offset().top : 0;
            //                 const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
            //                 const containerWidth = $container.width();
            //                 const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
            //                 const pageTop = window.scrollY;

            //                 // Verifica se existe banner e calcula quando ele sai da tela
            //                 let bannerOffset = 0;
            //                 if (banner) {
            //                     const bannerRect = banner.getBoundingClientRect();
            //                     const bannerHeight = banner.offsetHeight;
            //                     bannerOffset = bannerHeight;
            //                 }

            //                 // Calcula a altura do header para o top na volta
            //                 let headerHeight = 0;
            //                 if (appHeader) {
            //                     headerHeight = appHeader.offsetHeight;
            //                 }

            //                 // Limites de scroll baseados no container e header
            //                 const safeTotalHeight = Math.max(0, totalHeight);
            //                 const startScroll = containerTop - headerHeight; // ponto para começar a fixar
            //                 const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

            //                 if (pageTop <= startScroll) {
            //                     // Antes do container tocar o header: posição normal
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: "0px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else if (pageTop >= endScroll) {
            //                     // Depois do final do container: travado no rodapé do container
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else {
            //                     // Dentro da faixa: fixo logo abaixo do header e com a largura do container
            //                     $('.sidebar__inner').css({ position: 'fixed' });
            //                     $('.sidebar__inner').css({ top: headerHeight + "px" });
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }

            //                 lastScrollTop = pageTop;
            //             }
            //         }

            //         window.addEventListener('scroll', function () {
            //             if (screen.width > 991) {
            //                 const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //                 if (photoScroll) {
            //                     animeScroll();
            //                 }
            //             }
            //         });

            //         window.onresize = function () {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             if (photoScroll) {
            //                 if ($('.sidebar__inner').css('position') === 'fixed') {
            //                     const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                     const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                     const containerWidth = $container.width();
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }
            //             }
            //         };
            //     }
            // }
            if (photoArea.classList.contains('gallery-scroll')) {
                let productPhoto = document.querySelector('#product-photo');
                let productImage = productPhoto.querySelector('img');
                let imageHeight = productImage ? productImage.getBoundingClientRect().height : 0;
                productPhoto.style.maxHeight = imageHeight + 'px';

                let thumbsContainer = document.querySelector('.product-detail__header--photoArea-thumbs');
                if (thumbsContainer) {
                    thumbsContainer.style.maxHeight = imageHeight + 'px';
                }

                let thumbsLarge = document.querySelectorAll('#product-photo a');
                let miniThumbs = document.querySelectorAll('.product-detail__header--photoArea-thumbs #photo-list li');
                if (thumbsLarge.length && miniThumbs.length) {
                    miniThumbs.forEach((thumb, index) => {
                        thumb.addEventListener('click', (e) => {
                            // Centraliza a thumb clicada no container de thumbs
                            thumb.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            });

                            // Navega para a foto principal correspondente
                            const target = thumbsLarge[index];
                            if (target) {
                                target.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        });
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const otherElement = document.querySelector(".product-detail__fixed--buy");

            if (!buyButton || !otherElement) return;

            const rect = buyButton.getBoundingClientRect();
            const isMobile = window.matchMedia("(max-width: 991px)").matches;

            if (isMobile) {
                // Buy button passou completamente pelo topo
                if (rect.bottom < 0) {
                    otherElement.classList.add("active");
                } else {
                    otherElement.classList.remove("active");
                }

                return;
            }

            // Desktop mantém o comportamento original
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                otherElement.classList.remove("active");
            } else {
                otherElement.classList.add("active");
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {

        const productPanel = document.querySelector('.product-detail__panel-drawer');
        const productPanelOverlay = document.querySelector('.product-detail__panel-overlay');
        const productPanelTriggers = document.querySelectorAll('[data-product-panel-target]');
        const productPanelCloseButtons = document.querySelectorAll('[data-product-panel-close]');
        let lastProductPanelTrigger = null;

        if (productPanel && productPanelOverlay && productPanelTriggers.length) {
            const closeProductPanel = () => {
                productPanel.classList.remove('active');
                productPanelOverlay.classList.remove('active');
                productPanel.setAttribute('aria-hidden', 'true');
                productPanelOverlay.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('product-panel-open');
                productPanelTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));

                if (lastProductPanelTrigger) {
                    lastProductPanelTrigger.focus();
                }
            };

            const openProductPanel = (target, trigger) => {
                const targetSection = productPanel.querySelector(`[data-product-panel="${target}"]`);
                if (!targetSection) return;

                productPanel.querySelectorAll('[data-product-panel]').forEach(section => {
                    section.classList.toggle('active', section === targetSection);
                });

                lastProductPanelTrigger = trigger;
                productPanelTriggers.forEach(item => item.setAttribute('aria-expanded', 'false'));
                trigger.setAttribute('aria-expanded', 'true');
                productPanel.classList.add('active');
                productPanelOverlay.classList.add('active');
                productPanel.setAttribute('aria-hidden', 'false');
                productPanelOverlay.setAttribute('aria-hidden', 'false');
                document.body.classList.add('product-panel-open');
                productPanel.focus();
            };

            productPanelTriggers.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    openProductPanel(trigger.dataset.productPanelTarget, trigger);
                });
            });

            productPanelCloseButtons.forEach(button => {
                button.addEventListener('click', closeProductPanel);
            });

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && productPanel.classList.contains('active')) {
                    closeProductPanel();
                }
            });
        }

        document.querySelectorAll('.brogan-product-accordion__item').forEach((item) => {
            const trigger = item.querySelector('.brogan-product-accordion__trigger');
            const content = item.querySelector('.brogan-product-accordion__content');

            if (!trigger || !content) return;

            const updateAccordion = (open) => {
                item.classList.toggle('active', open);
                trigger.setAttribute('aria-expanded', String(open));
                content.style.maxHeight = open ? `${content.scrollHeight}px` : '0px';
            };

            updateAccordion(item.classList.contains('active'));
            trigger.addEventListener('click', () => updateAccordion(!item.classList.contains('active')));
        });

        const productSummary = document.querySelector('.product-detail__summary');
        if (productSummary) {
            const productSummaryContent = productSummary.querySelector('.product-detail__summary-content');
            const productSummaryToggle = productSummary.querySelector('.product-detail__summary-toggle');

            if (productSummaryContent && productSummaryToggle) {
                const collapsedLineLimit = 8;

                const updateCollapsedHeight = () => {
                    const contentTop = productSummaryContent.getBoundingClientRect().top;
                    const walker = document.createTreeWalker(
                        productSummaryContent,
                        NodeFilter.SHOW_TEXT,
                        {
                            acceptNode: node => node.textContent.trim()
                                ? NodeFilter.FILTER_ACCEPT
                                : NodeFilter.FILTER_REJECT
                        }
                    );
                    const range = document.createRange();
                    const lines = [];
                    let textNode = walker.nextNode();

                    while (textNode) {
                        range.selectNodeContents(textNode);
                        Array.from(range.getClientRects()).forEach(rect => {
                            if (!rect.width || !rect.height) return;

                            const currentLine = lines.find(line => Math.abs(line.top - rect.top) < 1);
                            if (currentLine) {
                                currentLine.bottom = Math.max(currentLine.bottom, rect.bottom);
                            } else {
                                lines.push({ top: rect.top, bottom: rect.bottom });
                            }
                        });
                        textNode = walker.nextNode();
                    }

                    range.detach();
                    lines.sort((firstLine, secondLine) => firstLine.top - secondLine.top);

                    const lastVisibleLine = lines[Math.min(collapsedLineLimit, lines.length) - 1];
                    const collapsedHeight = lines.length > collapsedLineLimit && lastVisibleLine
                        ? Math.ceil(lastVisibleLine.bottom - contentTop + 1)
                        : productSummaryContent.scrollHeight;

                    productSummaryContent.style.setProperty(
                        '--product-summary-collapsed-height',
                        `${collapsedHeight}px`
                    );
                };

                const updateExpandedHeight = () => {
                    productSummaryContent.style.setProperty(
                        '--product-summary-expanded-height',
                        `${productSummaryContent.scrollHeight}px`
                    );
                };

                const updateProductSummary = () => {
                    if (productSummary.classList.contains('is-expanded')) return;

                    const hasOverflow = productSummaryContent.scrollHeight > productSummaryContent.clientHeight + 1;
                    productSummaryToggle.hidden = !hasOverflow;
                };

                const updateProductSummaryLayout = () => {
                    updateCollapsedHeight();
                    if (productSummary.classList.contains('is-expanded')) {
                        updateExpandedHeight();
                    } else {
                        updateProductSummary();
                    }
                };

                const updateProductSummaryWithoutAnimation = () => {
                    productSummary.classList.remove('is-summary-ready');
                    productSummaryContent.getBoundingClientRect();
                    updateProductSummaryLayout();
                    requestAnimationFrame(() => productSummary.classList.add('is-summary-ready'));
                };

                productSummaryToggle.addEventListener('click', () => {
                    updateExpandedHeight();
                    const isExpanded = productSummary.classList.toggle('is-expanded');
                    productSummaryToggle.setAttribute('aria-expanded', String(isExpanded));
                    productSummaryToggle.textContent = isExpanded ? 'Ver menos' : 'Ver mais';
                });

                window.addEventListener('resize', updateProductSummaryWithoutAnimation, { passive: true });

                requestAnimationFrame(updateProductSummaryWithoutAnimation);
                window.addEventListener('load', updateProductSummaryWithoutAnimation, { once: true });
            }
        }

        const groupSizeTitle = document.querySelector('.group-size .group-size-title');
        const productRadioVariation = document.querySelector('.product-radio-variation .label_attributes');
        if (groupSizeTitle && productRadioVariation) {
            groupSizeTitle.textContent = productRadioVariation.textContent;
        }

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        this.clickThumbs();

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

/**
 * Modal customizado da galeria do produto.
 * Mantém a URL limpa e reúne fotos e vídeos do mesmo grupo.
 */
;(function () {
    const YOUTUBE_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
    const VIDEO_REGEX = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;
    const MOBILE_QUERY = window.matchMedia('(max-width: 991px)');
    const ZOOM_SCALE = 2.5;
    const PINCH_MAX = 4;
    const PINCH_MIN = 0.5;
    const PINCH_CLOSE = 0.8;
    const DISMISS_DISTANCE = 120;
    const DOUBLE_TAP_MS = 300;
    const TAP_TOLERANCE = 10;

    let modal = null;
    let slider = null;
    let counter = null;
    let prevArrow = null;
    let nextArrow = null;
    let zoomButton = null;
    let backdrop = null;

    const pinch = {
        img: null,
        mode: null,
        scale: 1,
        x: 0,
        y: 0,
        startScale: 1,
        startDistance: 0,
        anchorX: 0,
        anchorY: 0,
        startX: 0,
        startY: 0,
        panX: 0,
        panY: 0,
        moved: false,
        lastTap: 0,
        directionChecked: false
    };

    function youtubeSlide(id) {
        return `<div class="gallery-modal__slide"><iframe src="https://www.youtube.com/embed/${id}?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }

    function videoSlide(src) {
        return `<div class="gallery-modal__slide"><video controls playsinline><source src="${src}"></video></div>`;
    }

    function buildSlide(item) {
        const src = item.src;

        if (item.type === 'youtube') {
            const match = src.match(YOUTUBE_REGEX);
            return youtubeSlide(match ? match[1] : src);
        }

        if (item.type === 'video') return videoSlide(src);

        const youtube = src.match(YOUTUBE_REGEX);
        if (youtube) return youtubeSlide(youtube[1]);
        if (VIDEO_REGEX.test(src)) return videoSlide(src);

        return `<div class="gallery-modal__slide"><img src="${src}" alt=""></div>`;
    }

    function currentImage() {
        return slider.querySelector('.slick-current img');
    }

    function setSwipe(enabled) {
        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('slickSetOption', 'swipe', enabled, false);
        }
    }

    function touchDistance(touches) {
        return Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    }

    function touchCenter(touches) {
        return {
            x: (touches[0].clientX + touches[1].clientX) / 2,
            y: (touches[0].clientY + touches[1].clientY) / 2
        };
    }

    function imageCenter(img) {
        const rect = img.parentElement.getBoundingClientRect();
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    }

    function visibleSize(img) {
        const boxWidth = img.offsetWidth;
        const boxHeight = img.offsetHeight;
        const ratio = img.naturalWidth / img.naturalHeight || boxWidth / boxHeight;

        if (boxWidth / boxHeight > ratio) return { width: boxHeight * ratio, height: boxHeight };
        return { width: boxWidth, height: boxWidth / ratio };
    }

    function setBackdropOpacity(opacity, animate) {
        if (!backdrop) return;
        backdrop.style.transition = animate ? 'opacity .25s ease' : 'none';
        backdrop.style.opacity = opacity;
    }

    function applyPinch(animate) {
        if (!pinch.img) return;

        const size = visibleSize(pinch.img);
        const slide = pinch.img.parentElement;
        const limitX = Math.max((size.width * pinch.scale - slide.offsetWidth) / 2, 0);
        const limitY = Math.max((size.height * pinch.scale - slide.offsetHeight) / 2, 0);

        pinch.x = Math.min(Math.max(pinch.x, -limitX), limitX);
        pinch.y = Math.min(Math.max(pinch.y, -limitY), limitY);
        pinch.img.style.transition = animate ? 'transform .25s ease' : 'none';
        pinch.img.style.transform = `translate(${pinch.x}px, ${pinch.y}px) scale(${pinch.scale})`;
    }

    function resetPinch() {
        if (pinch.img) {
            pinch.img.style.transform = '';
            pinch.img.style.transition = '';
        }

        pinch.img = null;
        pinch.mode = null;
        pinch.scale = 1;
        pinch.x = 0;
        pinch.y = 0;
        modal.classList.remove('is-pinched');
        setBackdropOpacity('', false);
        setSwipe(true);
    }

    function zoomAt(scale, clientX, clientY) {
        const center = imageCenter(pinch.img);
        const pointX = (clientX - center.x - pinch.x) / pinch.scale;
        const pointY = (clientY - center.y - pinch.y) / pinch.scale;

        pinch.scale = scale;
        pinch.x = clientX - center.x - scale * pointX;
        pinch.y = clientY - center.y - scale * pointY;
    }

    function onTouchStart(event) {
        if (!MOBILE_QUERY.matches) return;

        const img = currentImage();
        if (!img || !event.target.closest('.slick-current')) return;

        if (pinch.img !== img) {
            resetPinch();
            pinch.img = img;
        }

        if (event.touches.length === 2) {
            event.preventDefault();
            event.stopPropagation();

            const center = touchCenter(event.touches);
            const imgCenter = imageCenter(img);
            pinch.mode = 'pinch';
            pinch.moved = true;
            pinch.startScale = pinch.scale;
            pinch.startDistance = touchDistance(event.touches);
            pinch.anchorX = (center.x - imgCenter.x - pinch.x) / pinch.scale;
            pinch.anchorY = (center.y - imgCenter.y - pinch.y) / pinch.scale;
            setSwipe(false);
            return;
        }

        if (event.touches.length !== 1) return;

        pinch.moved = false;
        pinch.directionChecked = false;
        pinch.startX = event.touches[0].clientX;
        pinch.startY = event.touches[0].clientY;
        pinch.panX = pinch.x;
        pinch.panY = pinch.y;

        if (pinch.scale > 1) {
            pinch.mode = 'pan';
            event.stopPropagation();
        } else {
            pinch.mode = null;
        }
    }

    function onTouchMove(event) {
        if (!MOBILE_QUERY.matches || !pinch.img) return;

        if (pinch.mode === 'pinch' && event.touches.length === 2) {
            event.preventDefault();
            event.stopPropagation();

            const center = touchCenter(event.touches);
            const imgCenter = imageCenter(pinch.img);
            const scale = pinch.startScale * touchDistance(event.touches) / pinch.startDistance;
            pinch.scale = Math.min(Math.max(scale, PINCH_MIN), PINCH_MAX);
            pinch.x = center.x - imgCenter.x - pinch.scale * pinch.anchorX;
            pinch.y = center.y - imgCenter.y - pinch.scale * pinch.anchorY;
            applyPinch(false);
            setBackdropOpacity(pinch.scale < 1 ? pinch.scale : '', false);
            return;
        }

        if (event.touches.length !== 1) return;

        const deltaX = event.touches[0].clientX - pinch.startX;
        const deltaY = event.touches[0].clientY - pinch.startY;
        if (Math.abs(deltaX) > TAP_TOLERANCE || Math.abs(deltaY) > TAP_TOLERANCE) pinch.moved = true;

        if (pinch.mode === null && pinch.moved && !pinch.directionChecked) {
            pinch.directionChecked = true;
            if (Math.abs(deltaY) > Math.abs(deltaX)) pinch.mode = 'dismiss';
        }

        if (pinch.mode === 'dismiss') {
            event.preventDefault();
            event.stopPropagation();
            pinch.img.style.transition = 'none';
            pinch.img.style.transform = `translateY(${deltaY}px)`;
            setBackdropOpacity(Math.max(1 - Math.abs(deltaY) / (window.innerHeight / 2), 0.2), false);
            return;
        }

        if (pinch.mode === 'pan') {
            event.preventDefault();
            event.stopPropagation();
            pinch.x = pinch.panX + deltaX;
            pinch.y = pinch.panY + deltaY;
            applyPinch(false);
        }
    }

    function onTouchEnd(event) {
        if (!MOBILE_QUERY.matches || !pinch.img) return;

        if (pinch.mode === 'pinch' && event.touches.length === 1) {
            pinch.mode = pinch.scale > 1 ? 'pan' : null;
            pinch.directionChecked = true;
            pinch.startX = event.touches[0].clientX;
            pinch.startY = event.touches[0].clientY;
            pinch.panX = pinch.x;
            pinch.panY = pinch.y;
            return;
        }

        if (event.touches.length) return;

        if (pinch.mode === 'dismiss') {
            const deltaY = event.changedTouches[0].clientY - pinch.startY;

            if (Math.abs(deltaY) > DISMISS_DISTANCE) {
                event.preventDefault();
                closeModal();
                return;
            }

            pinch.img.style.transition = 'transform .25s ease';
            pinch.img.style.transform = '';
            setBackdropOpacity('', true);
            pinch.mode = null;
            return;
        }

        if (pinch.scale < PINCH_CLOSE) {
            event.preventDefault();
            closeModal();
            return;
        }

        if (!pinch.moved) {
            const now = Date.now();

            if (now - pinch.lastTap < DOUBLE_TAP_MS) {
                const touch = event.changedTouches[0];

                if (pinch.scale > 1) {
                    pinch.scale = 1;
                    pinch.x = 0;
                    pinch.y = 0;
                } else {
                    zoomAt(ZOOM_SCALE, touch.clientX, touch.clientY);
                }

                applyPinch(true);
                pinch.lastTap = 0;
            } else {
                pinch.lastTap = now;
            }
        }

        if (pinch.scale <= 1.01) {
            pinch.scale = 1;
            pinch.x = 0;
            pinch.y = 0;
            applyPinch(true);
            setBackdropOpacity('', true);
        }

        const zoomed = pinch.scale > 1;
        modal.classList.toggle('is-pinched', zoomed);
        setSwipe(!zoomed);
        pinch.mode = null;
    }

    function moveZoom(clientX, clientY) {
        const img = currentImage();
        if (!img) return;

        const slideRect = img.parentElement.getBoundingClientRect();
        const x = (clientX - slideRect.left - img.offsetLeft) / img.offsetWidth;
        const y = (clientY - slideRect.top - img.offsetTop) / img.offsetHeight;
        const clamp = value => Math.min(Math.max(value, 0), 1) * 100;
        img.style.transformOrigin = `${clamp(x)}% ${clamp(y)}%`;
    }

    function zoomIn(clientX, clientY) {
        const img = currentImage();
        if (!img) return;

        modal.classList.add('is-zoomed');
        zoomButton.setAttribute('aria-pressed', 'true');
        zoomButton.setAttribute('aria-label', 'Reduzir');

        if (clientX === undefined) {
            img.style.transformOrigin = '50% 50%';
        } else {
            moveZoom(clientX, clientY);
        }

        img.style.transform = `scale(${ZOOM_SCALE})`;
        $(slider).slick('slickSetOption', 'swipe', false, false);
        $(slider).slick('slickSetOption', 'draggable', false, false);
    }

    function zoomOut() {
        if (!modal || !modal.classList.contains('is-zoomed')) return;

        modal.classList.remove('is-zoomed');
        zoomButton.setAttribute('aria-pressed', 'false');
        zoomButton.setAttribute('aria-label', 'Ampliar');
        slider.querySelectorAll('img').forEach(img => {
            img.style.transform = '';
            img.style.transformOrigin = '';
        });

        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('slickSetOption', 'swipe', true, false);
            $(slider).slick('slickSetOption', 'draggable', true, false);
        }
    }

    function updateStatus(current, total) {
        counter.textContent = `${current + 1} / ${total}`;
        prevArrow.disabled = current === 0;
        nextArrow.disabled = current === total - 1;
        zoomButton.hidden = !currentImage();
    }

    function closeModal() {
        if (!modal) return;

        zoomOut();
        resetPinch();
        modal.classList.remove('is-open');
        document.body.classList.remove('gallery-modal-open');

        if ($(slider).hasClass('slick-initialized')) $(slider).slick('unslick');
        slider.innerHTML = '';
    }

    function buildModal() {
        modal = document.createElement('div');
        modal.className = 'gallery-modal';
        modal.innerHTML = `
            <div class="gallery-modal__backdrop" data-gallery-close></div>
            <div class="gallery-modal__content">
                <span class="gallery-modal__counter"></span>
                <button type="button" class="gallery-modal__zoom" aria-label="Ampliar" aria-pressed="false">
                    <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M8 11h6"/><path class="gallery-modal__zoom-plus" d="M11 8v6"/></svg>
                </button>
                <button type="button" class="gallery-modal__close" aria-label="Fechar" data-gallery-close>
                    <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
                </button>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--prev" aria-label="Anterior">
                    <svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
                </button>
                <div class="gallery-modal__slider"></div>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--next" aria-label="Próximo">
                    <svg viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>
                </button>
            </div>
        `;
        document.body.appendChild(modal);

        slider = modal.querySelector('.gallery-modal__slider');
        counter = modal.querySelector('.gallery-modal__counter');
        prevArrow = modal.querySelector('.gallery-modal__arrow--prev');
        nextArrow = modal.querySelector('.gallery-modal__arrow--next');
        zoomButton = modal.querySelector('.gallery-modal__zoom');
        backdrop = modal.querySelector('.gallery-modal__backdrop');

        zoomButton.addEventListener('click', function () {
            if (modal.classList.contains('is-zoomed')) zoomOut();
            else zoomIn();
        });

        slider.addEventListener('click', function (event) {
            if (MOBILE_QUERY.matches) return;
            const img = event.target.closest('img');
            if (!img || img !== currentImage()) return;

            if (modal.classList.contains('is-zoomed')) zoomOut();
            else zoomIn(event.clientX, event.clientY);
        });

        slider.addEventListener('touchstart', onTouchStart, { capture: true, passive: false });
        slider.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
        slider.addEventListener('touchend', onTouchEnd, { capture: true });
        slider.addEventListener('touchcancel', onTouchEnd, { capture: true });
        slider.addEventListener('mousemove', function (event) {
            if (modal.classList.contains('is-zoomed')) moveZoom(event.clientX, event.clientY);
        });

        modal.addEventListener('click', function (event) {
            if (event.target.closest('[data-gallery-close]')) {
                closeModal();
                return;
            }

            if (!MOBILE_QUERY.matches && !event.target.closest('img, video, iframe, button')) closeModal();
        });

        prevArrow.addEventListener('click', () => $(slider).slick('slickPrev'));
        nextArrow.addEventListener('click', () => $(slider).slick('slickNext'));

        document.addEventListener('keydown', function (event) {
            if (!modal.classList.contains('is-open')) return;
            if (event.key === 'Escape') closeModal();
            if (event.key === 'ArrowLeft') $(slider).slick('slickPrev');
            if (event.key === 'ArrowRight') $(slider).slick('slickNext');
        });
    }

    function openModal(items, index) {
        if (!modal) buildModal();

        slider.innerHTML = items.map(buildSlide).join('');
        modal.classList.add('is-open');
        document.body.classList.add('gallery-modal-open');

        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: index,
            adaptiveHeight: false
        });

        $(slider).off('afterChange').on('afterChange', function (event, slick, currentSlide) {
            zoomOut();
            resetPinch();
            slider.querySelectorAll('video').forEach(video => video.pause());
            updateStatus(currentSlide, items.length);
        });

        updateStatus(index, items.length);
    }

    function sourceOf(element) {
        return element.getAttribute('href') || element.getAttribute('data-gallery-src');
    }

    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-gallery]');
        if (!trigger || !trigger.getAttribute('href')) return;

        event.preventDefault();
        const group = trigger.getAttribute('data-gallery');
        const members = Array.from(document.querySelectorAll(`[data-gallery="${group}"]`))
            .filter(item => sourceOf(item) && !item.closest('.slick-cloned'));
        const items = members.map(item => ({
            src: sourceOf(item),
            type: item.getAttribute('data-gallery-type') || ''
        }));

        let index = members.indexOf(trigger);
        if (index < 0) index = Math.max(items.findIndex(item => item.src === sourceOf(trigger)), 0);
        if (items.length) openModal(items, index);
    });
})();

$(document).ready(function () {

    const experienceMedia = document.querySelectorAll('#product-detail .banner-video-experiencia [data-experience-media]');

    if (experienceMedia.length) {
        const activateExperienceMedia = (media) => {
            if (media.tagName === 'VIDEO') {
                const source = media.querySelector('source[data-src]');

                if (source && !source.getAttribute('src')) {
                    source.src = source.dataset.src;
                    media.load();
                }

                media.muted = true;
                const playPromise = media.play();
                if (playPromise) playPromise.catch(() => {});
                return;
            }

            if (media.tagName === 'IFRAME' && !media.getAttribute('src')) {
                let mediaUrl = media.dataset.src;

                if (media.dataset.videoProvider === 'vimeo') {
                    try {
                        const vimeoUrl = new URL(mediaUrl, window.location.origin);
                        vimeoUrl.searchParams.set('autoplay', '1');
                        vimeoUrl.searchParams.set('muted', '1');
                        vimeoUrl.searchParams.set('loop', '1');
                        vimeoUrl.searchParams.set('background', '1');
                        vimeoUrl.searchParams.set('controls', '0');
                        mediaUrl = vimeoUrl.toString();
                    } catch (error) {
                        console.error('Não foi possível preparar o vídeo Vimeo da experiência:', error);
                    }
                }

                media.src = mediaUrl;
            }
        };

        if ('IntersectionObserver' in window) {
            const experienceObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        activateExperienceMedia(entry.target);

                        if (entry.target.tagName === 'IFRAME') {
                            experienceObserver.unobserve(entry.target);
                        }
                    } else if (entry.target.tagName === 'VIDEO') {
                        entry.target.pause();
                    }
                });
            }, { threshold: 0.2 });

            experienceMedia.forEach((media) => experienceObserver.observe(media));
        } else {
            experienceMedia.forEach((media) => {
                if (window.getComputedStyle(media).display !== 'none') {
                    activateExperienceMedia(media);
                }
            });
        }
    }

    waitForElementToExist('.product-detail-faq').then(element => { 
        const productDetailFaqListItems = document.querySelectorAll('.product-detail-faq-list-item');

        if(productDetailFaqListItems.length) {

            function activeTab(index) {
                productDetailFaqListItems[index].classList.toggle('active');
            }

            productDetailFaqListItems.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                });
            });
        }
    });

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
            addToCartButtons.forEach(button => {
                button.classList.add('no-buy');
            });
            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }


    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';
        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        const layout = document.querySelector('#js_buy_together_api_layout_1');
        const campaignNameSource = document.querySelector('#js_buy_together_api_layout_1_title');
        const payment = document.querySelector('#js_buy_together_api_layout_1_payment_conditions');
        if (!container || !layout) return;

        const getGroups = () => Array.from(container.children).filter(group => group.matches(GROUP_SELECTOR));

        const groupHasSelectedVariations = (group) => {
            const variationGroups = Array.from(group.querySelectorAll('.product-radio-variation'));
            const checkbox = group.querySelector('.checkbox-together-selectable');

            if (!variationGroups.some(variationGroup => variationGroup.querySelector('input[type="radio"]'))) {
                return !checkbox || checkbox.checked;
            }

            const hasSelectedVariations = variationGroups.every(variationGroup => {
                const availableRadios = Array.from(variationGroup.querySelectorAll('input[type="radio"]'))
                    .filter(input => !input.disabled);

                return availableRadios.length === 0 || availableRadios.some(input => input.checked);
            });

            return hasSelectedVariations && (!checkbox || checkbox.checked);
        };

        const getSelectedProductsCount = () => getGroups().filter(groupHasSelectedVariations).length;
        const hasMinimumSelectedProducts = () => getSelectedProductsCount() >= 2;

        const setSizeSelectorState = (group, open) => {
            const sizeOptions = Array.from(group.querySelectorAll('.product-radio-variation'));
            const toggle = group.querySelector('.checkbox-together');
            if (!sizeOptions.length || !toggle) return;

            group.classList.toggle('size-options-open', open);

            const interactiveControl = toggle.querySelector('input') || toggle;
            interactiveControl.setAttribute('aria-expanded', String(open));
        };

        const updateSizeSelectorSelection = (group) => {
            const toggle = group.querySelector('.checkbox-together--size-toggle');
            if (!toggle) return;

            const checkbox = toggle.querySelector('.checkbox-together-selectable');
            const isSelected = checkbox ? checkbox.checked : groupHasSelectedVariations(group);
            toggle.classList.toggle('is-selected', isSelected);
            toggle.setAttribute('aria-label', isSelected ? 'Produto selecionado' : 'Selecionar produto');

            const interactiveControl = toggle.querySelector('input') || toggle;
            interactiveControl.setAttribute('aria-pressed', String(isSelected));
        };

        const initializeSizeSelector = (group) => {
            if (group.dataset.sizeSelectorBound === '1') return;

            const product = group.querySelector('.product__product_detail_list');
            const infoProduct = group.querySelector('.info-product');
            const options = group.querySelector('.product-item__options');
            const sizeOptions = group.querySelectorAll('.product-radio-variation');
            if (!product || !infoProduct || !options || !sizeOptions.length) return;

            group.dataset.sizeSelectorBound = '1';

            if (options.parentElement !== infoProduct) {
                infoProduct.appendChild(options);
            }

            options.classList.add('buy-together-size-options');

            let toggle = product.querySelector('.checkbox-together');

            if (!toggle) {
                toggle = document.createElement('button');
                toggle.type = 'button';
                toggle.className = 'checkbox-together checkbox-together--size-toggle';
                toggle.setAttribute('aria-label', 'Escolher tamanho');
                product.appendChild(toggle);
            } else {
                toggle.classList.add('checkbox-together--size-toggle');
                const checkbox = toggle.querySelector('input');

                if (checkbox) {
                    checkbox.setAttribute('aria-label', 'Selecionar produto e escolher tamanho');
                }
            }

            setSizeSelectorState(group, false);
            updateSizeSelectorSelection(group);

            const checkbox = toggle.querySelector('.checkbox-together-selectable');
            if (checkbox) {
                checkbox.addEventListener('change', (event) => {
                    event.stopPropagation();

                    if (!checkbox.checked) {
                        group.querySelectorAll('.product-radio-variation input[type="radio"]')
                            .forEach(radio => {
                                radio.checked = false;
                            });
                    }

                    getGroups().forEach(item => {
                        if (item !== group) setSizeSelectorState(item, false);
                    });

                    const shouldOpen = checkbox.checked && !groupHasSelectedVariations(group);
                    setSizeSelectorState(group, shouldOpen);
                    updateSizeSelectorSelection(group);
                    scheduleSync();
                });
            }

            toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                getGroups().forEach(item => {
                    if (item !== group) setSizeSelectorState(item, false);
                });
            });

            options.addEventListener('click', (event) => {
                event.stopPropagation();
            });

            options.addEventListener('change', (event) => {
                if (event.target.matches('input[type="radio"]')) {
                    updateSizeSelectorSelection(group);
                    setSizeSelectorState(group, false);
                }
            });
        };

        const syncSizeSelectors = () => {
            getGroups().forEach(initializeSizeSelector);
        };

        const syncCampaignName = () => {
            const sourceTitle = campaignNameSource ? campaignNameSource.querySelector('.title') : null;
            const groups = getGroups();
            const mainGroup = groups.find(group => group.dataset.isMasterGroup === 'true') || groups[0];
            const mainProductName = mainGroup ? mainGroup.querySelector('.product-item__content--figcaption-name a') : null;
            const baseTitle = mainProductName ? mainProductName.textContent.trim() : sourceTitle ? sourceTitle.textContent.trim() : '';
            if (!baseTitle || !payment || !payment.children.length) return;

            let price = payment.querySelector(':scope > .price-buy-together');

            if (!price) {
                const addCartButton = payment.querySelector(':scope > #js_buy_together_api_add_cart');
                price = document.createElement('div');
                price.className = 'price-buy-together';

                while (payment.firstChild && payment.firstChild !== addCartButton) {
                    price.appendChild(payment.firstChild);
                }

                payment.insertBefore(price, addCartButton);
            }

            let campaignName = price.querySelector(':scope > .buy-together-campaign-name');

            if (!campaignName) {
                campaignName = document.createElement('h2');
                campaignName.className = 'buy-together-campaign-name';
                price.insertBefore(campaignName, price.firstElementChild);
            }

            const selectedAccessories = groups.filter(group => {
                if (group.dataset.isMasterGroup === 'true') return false;

                const selectableCheckbox = group.querySelector('.checkbox-together-selectable');
                const sizeToggle = group.querySelector('.checkbox-together--size-toggle');

                if (selectableCheckbox) {
                    return selectableCheckbox.checked || Boolean(sizeToggle && sizeToggle.classList.contains('is-selected'));
                }
                if (sizeToggle) return sizeToggle.classList.contains('is-selected');

                return groupHasSelectedVariations(group);
            }).length;
            const accessoriesLabel = selectedAccessories === 1 ? 'acessório' : 'acessórios';
            const accessoriesSuffix = selectedAccessories ? ` + ${selectedAccessories} ${accessoriesLabel}` : '';
            const title = `${baseTitle}${accessoriesSuffix}`;

            if (campaignName.textContent !== title) campaignName.textContent = title;
            campaignName.hidden = !title;
        };

        const syncUI = () => {
            const groups = getGroups();

            groups.forEach(group => {
                const checkbox = group.querySelector('.checkbox-together-selectable');
                const hasSizeRadios = group.querySelector('.product-radio-variation input[type="radio"]');

                if (!hasSizeRadios && checkbox && group.dataset.noSizeSelectionInitialized !== '1') {
                    checkbox.checked = false;
                    group.dataset.noSizeSelectionInitialized = '1';
                }
            });

            syncSizeSelectors();
            syncCampaignName();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            const selectedProductsCount = getSelectedProductsCount();

            groups.forEach(group => {
                const checkbox = group.querySelector('.checkbox-together-selectable');
                const toggle = group.querySelector('.checkbox-together');
                const hasSizeRadios = group.querySelector('.product-radio-variation input[type="radio"]');

                if (!hasSizeRadios && checkbox && toggle) {
                    toggle.classList.add('checkbox-together--size-toggle');
                    toggle.classList.toggle('is-selected', checkbox.checked);
                }

                updateSizeSelectorSelection(group);
                group.classList.toggle('please-select', selectedProductsCount < 2 && !groupHasSelectedVariations(group));
            });

            const canBuyTogether = selectedProductsCount >= 2;
            const mustDisable = !canBuyTogether;
            addCartBtn.classList.toggle('no-buy', !canBuyTogether);

            if (addCartBtn.disabled !== mustDisable) {
                addCartBtn.disabled = mustDisable;
            }

            if (addCartBtn.getAttribute('aria-disabled') !== String(mustDisable)) {
                addCartBtn.setAttribute('aria-disabled', String(mustDisable));
            }
        };

        let syncQueued = false;
        const scheduleSync = () => {
            if (syncQueued) return;

            syncQueued = true;
            Promise.resolve().then(() => {
                syncQueued = false;
                syncUI();
            });
        };

        container.addEventListener('change', scheduleSync, { passive: true });

        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;

            const group = target.closest(GROUP_SELECTOR);
            const hasSizeRadios = group && group.querySelector('.product-radio-variation input[type="radio"]');
            const isSizeToggle = target.closest('.checkbox-together');

            if ((isSizeToggle && hasSizeRadios) || target.closest('.buy-together-size-options')) {
                e.stopPropagation();
            }

            if (target.closest('label') || target.matches('input')) {
                scheduleSync();
            }
        }, { passive: true });

        document.addEventListener('click', (event) => {
            const target = event.target;
            if (!(target instanceof Element) || target.closest(GROUP_SELECTOR)) return;

            getGroups().forEach(group => setSizeSelectorState(group, false));
        });

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;

            getGroups().forEach(group => setSizeSelectorState(group, false));
        });

        layout.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element) || !target.closest(ADD_CART_BTN_SELECTOR)) return;

            if (!hasMinimumSelectedProducts()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                syncUI();
            }
        }, true);

        const observer = new MutationObserver(scheduleSync);
        observer.observe(layout, {
            childList: true,
            subtree: true
        });

        syncUI();
    });

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const mobileSlider = $('.mobile-slider');
    const mobileThumbs = document.querySelector('.product-detail__mobile-thumbs');

    if (mobileSlider.length && mobileThumbs) {
        const mobileSlides = Array.from(mobileSlider[0].children)
            .filter(slide => slide.classList.contains('mobile-slider-item'));

        mobileSlides.forEach((slide, index) => {
            const thumbButton = document.createElement('button');
            const sourceMedia = slide.querySelector('img, video');
            const isVideo = Boolean(slide.querySelector('video, iframe'));

            thumbButton.type = 'button';
            thumbButton.className = 'product-detail__mobile-thumb';
            thumbButton.dataset.slideIndex = index;
            thumbButton.setAttribute('aria-label', `Ver mídia ${index + 1} do produto`);
            thumbButton.setAttribute('aria-pressed', String(index === 0));

            if (sourceMedia) {
                const thumbMedia = sourceMedia.cloneNode(true);
                thumbMedia.removeAttribute('id');

                if (thumbMedia.tagName === 'VIDEO') {
                    thumbMedia.removeAttribute('autoplay');
                    thumbMedia.removeAttribute('controls');
                    thumbMedia.removeAttribute('loop');
                    thumbMedia.muted = true;
                    thumbMedia.preload = 'metadata';
                }

                thumbButton.appendChild(thumbMedia);
            }

            if (isVideo) {
                const playIcon = document.createElement('span');
                playIcon.className = 'product-detail__mobile-thumb-play';
                playIcon.setAttribute('aria-hidden', 'true');
                thumbButton.appendChild(playIcon);
            }

            mobileThumbs.appendChild(thumbButton);
        });

        const mobileThumbButtons = Array.from(mobileThumbs.querySelectorAll('.product-detail__mobile-thumb'));
        const updateMobileThumbs = (index, scrollToThumb = false) => {
            mobileThumbButtons.forEach((button, buttonIndex) => {
                const isActive = buttonIndex === index;
                button.classList.toggle('active', isActive);
                button.setAttribute('aria-pressed', String(isActive));
            });

            const activeThumb = mobileThumbButtons[index];
            if (scrollToThumb && activeThumb) {
                const thumbsRect = mobileThumbs.getBoundingClientRect();
                const activeThumbRect = activeThumb.getBoundingClientRect();
                const centeredScrollPosition = mobileThumbs.scrollLeft
                    + activeThumbRect.left
                    - thumbsRect.left
                    - ((thumbsRect.width - activeThumbRect.width) / 2);

                mobileThumbs.scrollTo({
                    left: Math.max(0, centeredScrollPosition),
                    behavior: 'smooth'
                });
            }
        };

        mobileThumbs.addEventListener('click', (event) => {
            const thumbButton = event.target.closest('.product-detail__mobile-thumb');
            if (!thumbButton || !mobileSlider.hasClass('slick-initialized')) return;

            const slideIndex = Number(thumbButton.dataset.slideIndex);
            updateMobileThumbs(slideIndex, true);
            mobileSlider.slick('slickGoTo', slideIndex);
        });

        mobileSlider.on('init', (event, slick) => {
            updateMobileThumbs(slick.currentSlide || 0);
        });

        mobileSlider.on('afterChange', (event, slick, currentSlide) => {
            updateMobileThumbs(currentSlide, true);
        });

        updateMobileThumbs(0);
    }

    const mobileProductGallery = $('.product-detail__header--photoArea-mobile, .mobile-slider');
    if (mobileProductGallery.length) {
        mobileProductGallery.slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 500,
            cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel').length) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 900,
            fade: true,
            cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
            customPaging: function (slider, index) {
                const current = String(index + 1).padStart(2, '0');
                const total = String(slider.slideCount).padStart(2, '0');
                return `<button type="button" aria-label="Avaliação ${index + 1} de ${slider.slideCount}">${current} / ${total}</button>`;
            }
        });
    }
})
